@if (rows && columns && texts) {
  <div class="profile-management-container">
    <div class="buttons-container">
      <ds-button [iconRight]="'/public/assets/images/plus-circle.svg'" [text]="'buttons.new_profile' | translate" [width]="'small'" (click)="openModal()"></ds-button>
    </div>
    <div nz-row>
      <div class="content-container">
        <app-appointments-table
          (actionClicked)="getMedicalRecord()"
          [appointmentText]="texts"
          [searchEnabled]="true"
          [columns]="columns"
          [appointments]="rows"
        ></app-appointments-table>
      </div>
    </div>
  </div>
}
